const gql = require("graphql-tag");

const COMPANY_DELETE = gql`
  mutation($data: CompanyDeleteInput!) {
    companyRemove(data: $data) {
      n
      deletedCount
      ok
    }
  }
`;

const COMPANY_UPDATE = gql`
  mutation($data: CompanyUpdateInput!) {
    companyUpdate(data: $data) {
      n
      nModified
      ok
    }
  }
`;

const COMPANY_CREATE = gql`
  mutation($data: CompanyInput!) {
    companyCreate(data: $data) {
      id
      name
      type
      userlimit
      passiveDate
      description
      isActive
    }
  }
`;

export const companiesMutations = { 
  COMPANY_DELETE,
  COMPANY_UPDATE,
  COMPANY_CREATE,
};
